import React, {PureComponent} from 'react';
import toastr from 'toastr';
import newPlansEmitto from '../common/NewPlansEmitto.json'
import Loader from '../utils/loader'
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import PlanHeader from "./pricingPlanParts/PlanHeader";
import PlanChannelsBenefitsFeatures from "./pricingPlanParts/PlanChannelsBenefitsFeatures";
import PlanBottomButton from "./pricingPlanParts/PlanBottomButton";
import SubscriptionPlansHeader from "./pricingPlanParts/SubscritionPlansHeader";
import CustomPlan from "./pricingPlanParts/CustomPlan";
import {Link} from "react-router-dom";

// import ReactGA from "react-ga";


class SubscriptionPlans extends PureComponent {

    state = {
        plansLoading: true,
        spinnerActive: false,
        spinnerActivePlan: '',
        plans: '',
        selectedPlan: '',
        planPeriod: 'monthly',
        selectedSourceId: this.props.selectedSource,
        selectedSourceFull: '',
        selectedPlanId: '',
        activePlanInterval: '',
        selectedProject: '',
        chosenPlanFull: '',
        subscribedAt: '',
        projects: this.props.user.sources.data,
        user: this.props.user,
        showCustomPlan: false
    };

    updateUserFromServer = async () => {
        //console.info('entered updateUserFromServer')
        try {
            const user_id = await getCurrentUserId();
            if (user_id) {
                // const result = await http.get('api/user/' + user_id, {headers: {authorization: getJwt()}});
                const result = await http.get('api/user_info', {headers: {authorization: getJwt()}});
                const data = await result.data.data;
                let user = await data;
                await this.setState({
                    user: user
                });
                // console.log('User was updated: ', user)
            }
        } catch (e) {
            toastr.error("Getting User's data from server was unsuccessful")
        }

    }
    handleClose = () => {
        if (this.props.handleClose) {
            this.props.handleClose()
        }
    }
    componentDidMount = async () => {
        this.setState({
            plansLoading: true
        })
        document.querySelector('html').classList.add('font-size-16')

        let result = '';
        try {


            result = await http.get('api/emitto_plans/product/emitto_plans', {headers: {authorization: getJwt()}});

            //console.log('get plans result: ', result)
        } catch (e) {
            // console.log('plans call error: ', e)
        }
        if (result !== '') {
            await this.setState({
                plans: result.data
            })
        }
        //console.log('selectedSourceId: ', this.state.selectedSourceId)
        let selectedSourceFull = this.state.projects.find(selectedSource => {
            return selectedSource.id === this.state.selectedSourceId

        })
        // console.log('componentDidMount selectedSourceFull:', selectedSourceFull)
        let selectedPlanId = ''
        let activePlanInterval = ''
        if (selectedSourceFull && selectedSourceFull.plan) {
            selectedPlanId = selectedSourceFull.plan.plan_id
        }
        if (selectedSourceFull && selectedSourceFull.plan) {
            if (selectedSourceFull.plan) {

                activePlanInterval = selectedSourceFull.plan.interval
            }
        }
        //console.log('selectedPlan')
        this.setState({
            selectedSourceFull,
            selectedPlanId,
            activePlanInterval,
            planPeriod: activePlanInterval === 'year' ? 'yearly' : 'monthly'
        })
        document.querySelector('html').classList.add('font-size-16')

        setTimeout(() => {
            this.setState({showCustomPlan: true});
        }, 50)

        this.setState({
            plansLoading: false
        })
    }

    componentDidUpdate = async () => {
        if (this.state.selectedSourceId !== this.props.selectedSource) {
            let selectedSourceFull = this.state.projects.find(selectedSource => {
                return selectedSource.id === this.props.selectedSource

            })
            let selectedPlanId = ''

            if (selectedSourceFull.plan) {
                selectedPlanId = selectedSourceFull.plan.plan_id

            }
            //console.log('componentDidUpdate selectedSource: ', selectedSourceFull)
            this.setState({
                selectedSourceFull,
                selectedPlanId,
                selectedSourceId: this.props.selectedSource
            })
        }
    }

    togglePlanPeriod = async (period) => {
        //console.log('togglePlanPeriod: ', period)
        await this.setState({
            planPeriod: period
        })

    }

    handleSubscriptionCompleted = (planId) => {
        //console.log('planId: ', planId)
        if (planId === 'tester_monthly') {
            this.props.history.push('/tester-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/tester-monthly-confirmation',
                pageTitle: 'Tester Monthly Confirmation',
            });
        } else if (planId === 'starter_monthly') {
            this.props.history.push('/starter-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/essentials-monthly-confirmation',
                pageTitle: 'Essentials Monthly Confirmation',
            });
        } else if (planId === 'essentials_monthly') {
            this.props.history.push('/essentials-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/essentials-monthly-confirmation',
                pageTitle: 'Essentials Monthly Confirmation',
            });
        } else if (planId === 'boost_monthly') {
            this.props.history.push('/boost-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/boost-monthly-confirmation',
                pageTitle: 'Boost Monthly Confirmation',
            });
        } else if (planId === 'tester_yearly') {
            this.props.history.push('/tester-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/tester-yearly-confirmation',
                pageTitle: 'Tester Yearly Confirmation',
            })
        } else if (planId === 'starter_yearly') {
            this.props.history.push('/starter-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/starter-yearly-confirmation',
                pageTitle: 'Starter Yearly Confirmation',
            })
        } else if (planId === 'essentials_yearly') {
            this.props.history.push('/essentials-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/essentials-yearly-confirmation',
                pageTitle: 'Essentials Yearly Confirmation',
            });
        } else if (planId === 'boost_yearly') {
            this.props.history.push('/boost-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/boost-yearly-confirmation',
                pageTitle: 'Boost Yearly Confirmation',
            });
        } else {
            this.props.history.push('/subscription-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/subscription-confirmation',
                pageTitle: 'Subscription Confirmation',
            });
        }
    }

    componentWillUnmount = () => {
        //console.log('componentWillUnmount run')
        let htmlElement = document.querySelector('html')
        if (htmlElement.classList.contains('font-size-16')) {
            htmlElement.classList.remove('font-size-16')
        }
    }

    handlePremiumPlan = async (amount, planId, freeTrial = false) => {
        if (!amount || !planId) {
            toastr.error('Error with receiving amount or plan Id, please reload page and try again')
        } else {
            await this.setState({
                spinnerActive: true,
                spinnerActivePlan: planId,
            })
            // console.log('premium plan handled')
            // console.log('amount and planId: ', amount + ' ' + planId)
            await this.setState({
                //spinnerActive: true,
                chosen: true
            })
            let user = await this.props.user;
            let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
            let project = await user.sources.data.find(project => projectId.toString() === project.id.toString())
            let smsPlatform = project ? project.platforms.find(plan => plan.platform === 'sms') : '';
            let plan = smsPlatform ? smsPlatform.plan : '';
            let upcomingSwitchPlans = ''

            // console.log('user, projectId, project: ', user, projectId, project)
            if (user && user.customer && project) {
                // console.log('upcoming_switch_plans pres equal: ', plan, planId)
                let useDiscount = planId.includes('yearly');

                try {
                    const result = await http.post('/api/user/' + user.id + '/project/' + projectId + '/customers/upcoming_switch_plans', {
                        "plan": planId,
                        "use_discount": useDiscount,
                        "promo_code": ''
                    }, {headers: {authorization: getJwt()}});
                    upcomingSwitchPlans = await result.data.invoice_upcoming;
                    // console.log('upcoming_switch_plans: ', upcomingSwitchPlans)
                } catch (e) {
                    // console.log('')
                }
                // }

                /*GET PAYMENT METHODS PROJECT*/
                try {
                    const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                    // console.log('1:', result)
                    let projectPaymentMethods = result && result.data && result.data.project_payment_methods ? result.data.project_payment_methods : [];
                    let userPaymentMethods = await result && result.data && result.data.user_payment_methods ? result.data.user_payment_methods : [];
                    // console.log('2:', userPaymentMethods);
                    // console.log('payment methods: ', projectPaymentMethods, userPaymentMethods)

                    if (
                        (userPaymentMethods && userPaymentMethods.length && userPaymentMethods[0].payment_method_id) ||
                        (projectPaymentMethods && projectPaymentMethods.length && projectPaymentMethods[0].payment_method_id)
                    ) {
                        this.setState({clicked: true})
                        // console.log('Data for existing payment: ', amount, planId, this.state.planPeriod, freeTrial)

                        //console.log('handlePremiumPlan amount: ', amount)
                        this.props.history.push('/existing-payment', {
                            amount: amount,
                            stripePlanId: planId,
                            yearly: this.state.planPeriod,
                            freeTrial: freeTrial,
                            upcomingSwitchPlans,
                        })
                    } else {
                        this.setState({clicked: true})

                        // console.log('handlePremium->addFunds free trial: ', freeTrial)

                        // console.log('handlePremiumPlan amount: ', amount)
                        this.props.history.push('/add-funds/billing-details', {
                            amount: amount,
                            stripePlanId: planId,
                            yearly: this.state.planPeriod,
                            freeTrial: freeTrial,
                            upcomingSwitchPlans
                        })
                    }
                    // console.log('projectPaymentMethods: ', projectPaymentMethods);
                    // console.log('userPaymentMethods: ', userPaymentMethods);
                    this.setState({spinnerActive: ''})
                    this.updateUserFromServer();
                } catch (ex) {
                    toastr.error("Couldn't receive payment methods, please try again.");
                    this.setState({spinnerActive: ''})
                }

            } else if (user && !user.customer && project) {
                let userId = user.id || getCurrentUserId();
                let useDiscount = planId.includes('yearly');
                try {
                    const stripeResult = await http.post('api/user/' + userId + '/project/' + projectId + '/customers/create_customer', {}, {headers: {authorization: getJwt()}})
                    // console.log('customer:', stripeResult)
                    this.setState({clicked: true})
                    try {
                        const result = await http.post('/api/user/' + user.id + '/project/' + projectId + '/customers/upcoming_switch_plans', {
                            "plan": planId,
                            "use_discount": useDiscount,
                            "promo_code": ''
                        }, {headers: {authorization: getJwt()}});
                        upcomingSwitchPlans = await result.data.invoice_upcoming;

                        this.props.history.push('/add-funds/billing-details', {
                            amount: this.state.planPeriod ? amount * 0.8 : amount,
                            stripePlanId: planId,
                            upcomingSwitchPlans
                        })
                        // console.log('upcoming_switch_plans: ', upcomingSwitchPlans)
                    } catch (e) {
                        // console.log('')
                    }

                } catch (ex) {
                    toastr.error("Stripe customer was not created, please try again.");
                    this.setState({spinnerActive: ''})
                    this.props.updateUserFromServer();
                }
            }
            await this.setState({
                spinnerActive: false,
                spinnerActivePlan: ''
            })
        }
    }

    render() {
        let plansLength
        if (this.state.plans.data) {
            plansLength = this.state.plans.data.length
        }
        let selectedSourcePlanId = this.props?.selectedSourceNode?.plan?.plan_id ?? this.state.selectedSourceFull?.plan?.plan_id;
        let shouldShowTesterPlan = selectedSourcePlanId?.includes('tester_yearly') ||
            (selectedSourcePlanId?.includes('tester_monthly') && (this.state.planPeriod !== 'yearly')) ||
            ((window.location.pathname === "/subscription-plans-promo") && (this.state.planPeriod !== 'yearly'))
        // console.log('newPlansEmitto: ', newPlansEmitto)
        return (
            <React.Fragment>
                <div id='tailwind-pricing' className="bg-white font-poppins text-lightText">
                    {/*{console.log('%cshouldShowTesterPlan: ', 'color: white; background: blue; font-size: 24px', shouldShowTesterPlan, this.state.planPeriod, this.props?.selectedSourceNode?.plan?.plan_id)}*/}
                    <div
                        className={`mx-auto margin-bottom-30 px-6 lg:px-4`}>
                        <SubscriptionPlansHeader
                            togglePlanPeriod={this.togglePlanPeriod}
                            disabled={this.state.planPeriod === 'yearly'}
                            planPeriod={this.state.planPeriod}
                            activePlanInterval={this.state.activePlanInterval}
                        ></SubscriptionPlansHeader>
                        {/* Pricing plan cards */}
                        {this.state.plansLoading ?
                            <div className='pricing-loader'>
                                <Loader/>
                            </div>
                            :
                            <div
                                className={shouldShowTesterPlan ?
                                    "mt-12 space-y-4 sm:mt-16 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-6 lg:max-w-none lg:grid-cols-4 2xl:grid-cols-5 2xl:max-w-[1490px] mx-auto" :
                                    "mt-12 space-y-4 sm:mt-16 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-6 lg:max-w-none lg:grid-cols-3 2xl:grid-cols-4 2xl:max-w-[1490px] mx-auto"}>
                                {
                                    this.state.plans !== '' ? this.state.plans.data.length ?
                                            this.state.plans.data.map(
                                                plan => {
                                                    if ((plan.plan_id.includes(this.state.planPeriod)) && (shouldShowTesterPlan ? true : !plan.plan_id.includes('tester'))) {
                                                        return (
                                                            <div id={plan.plan_id} key={plan.plan_id}
                                                                 className={` ${plan.plan_id.includes('essentials') ? 'w-full 2xl:max-w-[280px] pt-8 rounded-lg shadow-sm relative h-[950px] lg:h-[1080px] xl:h-[970px] ' : '2xl:max-w-[280px] pt-8 rounded-lg shadow-sm relative h-[950px] lg:h-[1080px] xl:h-[970px]'} ${plan.plan_id.includes('boost') ? 'bg-gray-100' : ''} ${plan.plan_id === this.state.selectedPlanId ? 'current-plan-filter' : ''} grey-border`}>
                                                                <PlanHeader
                                                                    planId={plan.plan_id}
                                                                    selectedPlanId={this.state.selectedPlanId}
                                                                    planName={plan.name}
                                                                    price={plan.monthly_price}
                                                                    planPeriod={this.state.planPeriod}
                                                                    handlePremiumPlan={this.handlePremiumPlan}
                                                                    spinnerActive={this.state.spinnerActive}
                                                                    spinnerActivePlan={this.state.spinnerActivePlan}
                                                                />
                                                                <PlanChannelsBenefitsFeatures
                                                                    name={plan.name}
                                                                />
                                                                <PlanBottomButton
                                                                    planId={plan.plan_id}
                                                                    selectedPlanId={this.state.selectedPlanId}
                                                                    price={plan.monthly_price}
                                                                    handlePremiumPlan={this.handlePremiumPlan}
                                                                    planPeriod={this.state.planPeriod}
                                                                    spinnerActive={this.state.spinnerActive}
                                                                    spinnerActivePlan={this.state.spinnerActivePlan}
                                                                />
                                                            </div>


                                                        )
                                                    } else {
                                                        return ''
                                                    }

                                                })
                                            :
                                            ''
                                        : ''
                                }
                                {this.state.showCustomPlan ?
                                    < CustomPlan
                                        runIntercom={this.runIntercom}
                                    />
                                    : ''
                                }
                            < /div>
                        }
                    </div>

                </div>

                {
                    this.state.plansLoading ? '' :
                        window.location.href.indexOf("subscription-plans") > -1 ?
                            <div className='margin-bottom-30 text-center f-16'>
                                <Link to='/billing/subscriptions'>I don't need an upgrade right now.</Link>
                            </div>
                            :
                            <div className='margin-bottom-30 text-center f-16'>
                                <p onClick={this.handleClose}
                                   className='cursor-pointer dont-need'>I don't need an upgrade right now.</p>
                            </div>
                }

            </React.Fragment>
        )
    }
}

export default SubscriptionPlans;